import React from 'react';
import BasicPage from '../components/BasicPage';

const LoginRequired: React.FC = () => {
  return <BasicPage title="You must be logged in to view this page" />;
};

export default LoginRequired;
